import React from 'react';
import { RouteComponentProps } from 'react-router-dom';
import { Contract } from '../../types';
import { API } from 'aws-amplify';
import Loader from '../../Components/Loader';
import { message } from 'antd';
import ContractForm from './partials/ContractForm';
import mixpanel from 'mixpanel-browser';

type Props = RouteComponentProps<{ id: string }, {}, { record: any}> & {};
type State = {
  contract?: Contract | null;
  loading: boolean;
};
class Form extends React.Component<Props, State> {
  state = {
    contract: null,
    loading: false,
  };
  async componentDidMount(): Promise<void> {
    if (this.props.location.state?.record) {
      // We passed it from the list in the state
      this.setState({
        contract: this.props.location.state.record,
      });
      mixpanel.track('View Contractor', {
        id: this.props.location.state.record.id,
      });
    }
    if (this.props.match.params.id) {
      // We should load from the API
      try {
        this.setState({
          loading: true,
        });
        const contract = (await API.get(
          'EhcmsPortalApi',
          `/customer/contracts/${this.props.match.params.id}`,
          {},
        )) as Contract;
        // Mock
        // const contract = {
        //   id: 16,
        //   name: 'HPD - Camille',
        //   active: true,
        //   employee_id: [70, 'Camille Lahoud'],
        //   department_id: false,
        //   job_id: [63, 'Head of Platform Development'],
        //   date_start: '2019-11-01',
        //   date_end: false,
        //   trial_date_end: false,
        //   wage: 0,
        //   advantages: false,
        //   notes: false,
        //   state: 'open',
        //   company_id: [1, 'Edari'],
        //   kanban_state: 'normal',
        //   currency_id: [131, 'AED'],
        //   permit_no: false,
        //   visa_no: false,
        //   visa_expire: false,
        //   hr_responsible_id: false,
        //   calendar_mismatch: false,
        //   structure_type_id: [2, 'Monthly'],
        //   schedule_pay: 'monthly',
        //   resource_calendar_id: [1, 'Standard 40 hours/week'],
        //   hours_per_week: 40,
        //   full_time_required_hours: 40,
        //   is_fulltime: true,
        //   wage_type: 'monthly',
        //   hourly_wage: 0,
        //   date_generated_from: '2020-03-27 00:00:00',
        //   date_generated_to: '2020-04-30 23:59:59',
        //   company_country_id: [2, 'United Arab Emirates'],
        //   analytic_account_id: false,
        //   contract_length: '11',
        //   cost_card: [127, 'S00127'],
        //   activity_ids: [],
        //   activity_state: false,
        //   activity_user_id: false,
        //   activity_type_id: false,
        //   activity_date_deadline: false,
        //   activity_summary: false,
        //   activity_exception_decoration: false,
        //   activity_exception_icon: false,
        //   message_is_follower: false,
        //   message_follower_ids: [535],
        //   message_partner_ids: [],
        //   message_channel_ids: [],
        //   message_ids: [1034, 1033],
        //   message_unread: false,
        //   message_unread_counter: 0,
        //   message_needaction: false,
        //   message_needaction_counter: 0,
        //   message_has_error: false,
        //   message_has_error_counter: 0,
        //   message_attachment_count: 0,
        //   message_main_attachment_id: false,
        //   website_message_ids: [],
        //   message_has_sms_error: false,
        //   display_name: 'HPD - Camille',
        //   create_uid: [1, 'OdooBot'],
        //   create_date: '2020-03-27 15:23:39',
        //   write_uid: [1, 'OdooBot'],
        //   write_date: '2020-04-20 09:40:12',
        //   __last_update: '2020-04-20 09:40:12',
        // } as any;
        if (contract) {
          this.setState({
            contract,
            loading: false,
          });
          mixpanel.track('View Contractor', {
            id: contract.id,
          });
        }
      } catch (e) {
        message.error('Contract not found');
        this.props.history.goBack();
      }
    }
  }
  close = (): void => {
    this.props.history.goBack();
  };
  render(): React.ReactElement {
    if (this.state.loading) {
      return <Loader />;
    }
    if (this.state.contract) {
      return <ContractForm record={this.state.contract} close={this.close} />;
    }
    return <Loader />;
  }
}

export default Form;
